// extracted by mini-css-extract-plugin
export default {"customCheckboxContainer":"CustomCheckbox_customCheckboxContainer__nN+AD","label":"CustomCheckbox_label__RP68I"};